var _path, _path2, _ellipse;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconQuestion = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.74 2h12.54A1.72 1.72 0 0120 3.73v12.14a1.71 1.71 0 01-1.72 1.7h-2.2a.23.23 0 00-.07.15 6.76 6.76 0 00.55 2.39l.82 1.89-1.86-.9a11.71 11.71 0 01-3.9-3.47.14.14 0 00-.09 0H5.77A1.72 1.72 0 014 15.9V3.73A1.72 1.72 0 015.74 2zm12.54 1.55H5.74a.19.19 0 00-.18.18V15.9a.18.18 0 00.18.18h5.76a1.7 1.7 0 011.29.6l.2.25a13.42 13.42 0 001.45 1.57l.07.07v-.22-.61a1.77 1.77 0 01.42-1.15 1.64 1.64 0 011.21-.54h2.18a.19.19 0 00.18-.18V3.73a.2.2 0 00-.22-.18z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.52 7.19a2.49 2.49 0 00-2.29-1.31 2.51 2.51 0 00-2.58 2.21.43.43 0 00.11.36.46.46 0 00.35.16h.59a.46.46 0 00.46-.38 1 1 0 011.07-.86 1 1 0 01.94.5.75.75 0 010 .79 2.33 2.33 0 01-.55.49 2 2 0 00-1 1.77.43.43 0 00.11.33.48.48 0 00.35.16h.57a.46.46 0 00.46-.43.6.6 0 01.36-.61 3.25 3.25 0 00.9-.81 2.24 2.24 0 00.15-2.37z"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.32,
  cy: 12.81,
  rx: 0.89,
  ry: 0.88
})));

export default SvgIconQuestion;